import angular from 'angular'
import './pack_maintenance.service'

angular
  .module('admin.pack_maintenance', ['admin.pack_maintenance.service'])
  .controller('PackMaintenanceCtrl', PackMaintenanceCtrl)

/** @ngInject */
function PackMaintenanceCtrl($state, $rootScope, PackMaintenanceService) {
  var vm = this
  vm.items = []
  vm.perPage = 25

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    PackMaintenanceService.list(vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  load(1)

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }
}
